<template>
	<div class="home">
		<HeaderBar :title="title"></HeaderBar>
		<div class="center-box-no-footer">
			<van-search v-model="searchValue" show-action placeholder="搜索..." @search="onSearch" clearable>
				<template #action>
					<div @click="onSearch" class="filter-box">
						筛选
						<van-icon name="filter-o" />
					</div>
				</template>
			</van-search>
			<van-list offset="10" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad"
				class="list-box">
				<div class="list-cell" v-for="item in list" v-bind:key="item.guid">
					<div class="list-cell-header">
						<div class="cell-header-left van-ellipsis">
							{{item.bq001001}}
							<!-- {{item.bq001018.substring(0,6)}}******{{item.bq001018.substring(12)}} -->
						</div>
					</div>
					<div class="list-cell-main">
						<BaseColumn label="患者姓名" :text="item.bq001002"></BaseColumn>
						<BaseColumn label="性别" :text="item.bq001003==1?'男':'女'"></BaseColumn>
						<BaseColumn label="中心" :text="item.EmployerName"></BaseColumn>
						<BaseColumn label="随访名称" :text="item.bs025003"></BaseColumn>
					</div>
					<div class="list-cell-footer">
						<van-button type="info" style="color: green;" class="footer-button" size="small"
							@click="Detail(item)">随访详情
						</van-button>
						<van-button type="info" class="footer-button" size="small" @click="statusSave(item)">提交转化
						</van-button>
						<van-button type="info" style="color: orangered;" class="footer-button" size="small"
							@click="showError(item)">异常追溯
						</van-button>
					</div>
				</div>
			</van-list>
			<van-popup v-model="showDetailPopup" closeable position="right" :style="{ width: '100%','height':'100%' }">
				<div class="setting-right-content">
					<followRecordIndex v-if="showDetailPopup"></followRecordIndex>
				</div>
			</van-popup>
			<van-dialog v-model="showSubmitDialog" title="提交" show-cancel-button :before-close="beforeSubmit">
				<van-form :model="submitModel">
					<FormNormalInput v-model="submitModel.Bq400record_Remark" label="提交说明"></FormNormalInput>
				</van-form>
			</van-dialog>

			<van-dialog v-model="showErrorDialog" title="异常详情">
				<van-steps direction="vertical" :active="0" active-color="#000">
					<van-step v-for="item in errorList" :key="item.id">
						<h3>{{item.bq4009962}}</h3>
						<p>说明：{{item.Bq400record_Remark==''?'无':item.Bq400record_Remark}}</p>
						<p class="message">{{item.addUserName +' 提交于：'+item.addTime}}</p>
					</van-step>
				</van-steps>
			</van-dialog>

		</div>
		<FooterBar></FooterBar>
	</div>
</template>

<script>
	import followRecordIndex from '../followRecord/index.vue'
	export default {
		name: 's400PatientList',
		data() {
			return {
				condition: {
					bq001018: "",
					bq001002: "",
					bq001042: '1',
					bq400996: 2,
					currentPage: 1,
					pageSize: 10,
					recordCount: 0,
					menuid: this.$utils.MenuEnum.error,

				},
				title: '质疑管理',
				searchUrl: this.$utils.Url.s400 + '/api/S400Bq400/List',
				loading: false,
				finished: false,
				searchValue: "",
				list: [],
				// 详情功能
				showDetailPopup: false,
				// 提交数据
				submitModel: {
					id: "0", //编号
					guid: "", //guid编号
					companyGuid: "", //单位编号
					departmentGuid: "", //部门编号
					checkStatus: "", //审核状态
					dataStatus: "", //数据状态
					addUid: "", //添加人编号
					addTime: "", //添加时间
					bq400recordRemark: "", //修改说明
					bq400996: "", //当前修改状态
					bq4009962: "", //当前状态名称
					bq400guid: "", //随访编号
					addUserName: "", //修改人姓名
					Bq400record_Remark: '', //修改说明
					Bq400_996: '', //当前修改状态
					Bq400_996_2: '', //当前状态名称
					Bq400_guid: '', //随访编号
				},
				// 提交数据窗口变量
				showSubmitDialog: false,
				// 异常数据窗口变量
				showErrorDialog: false,
				errorList: [],
			}

		},
		components: {
			followRecordIndex
		},
		methods: {
			onLoad() {
				let that = this
				that.loading = true
				that.$utils.HttpPost(that.searchUrl, that.condition, function(data) {
					console.log(data);
					let dataList = data.data
					dataList.forEach(function(item) {
						that.$utils.CopyKeyInfo(item, item)
						that.list.push(item)
					})
					if (that.list.length >= data.pager.RecordCount) {
						that.finished = true
					}
					that.loading = false
				})
			},
			onSearch() {
				let that = this
				that.condition.currentPage = 1
				that.condition.bq001002 = this.searchValue
				that.finished = false
				that.list = []
				that.onLoad()
			},
			// 查看随访详情
			Detail(row) {
				sessionStorage.setItem('bq400', JSON.stringify(row))
				this.showDetailPopup = true
			},
			//保存状态
			statusSave: function(row) {
				let that = this

				// that.submitModel.bq001018 = row.bq001018
				that.submitModel.bq400guid = row.guid
				that.submitModel.bq4009962 = '重新提交转化'
				that.submitModel.bq400996 = 1
				that.submitModel.bq400recordRemark = ""
				that.showSubmitDialog = true
				that.$utils.CopyKeySave(that.submitModel, that.submitModel)
			},
			// 弹窗关闭事件之前，校验是否已经有值
			beforeSubmit: function(action, done) {
				let that = this
				if (action == "confirm") {
					//if (that.submitModel.Bq400record_Remark) {
						// that.submitModel.Bq400record_Remark = that.submitModel.bq400recordRemark
						that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400record/Save/', that.submitModel,
							function() {
								that.$dialog({
									message: "修改成功"
								})
								that.onSearch()
								done()
							}, null, null, null)
					// } else {
					// 	that.$toast("请提交说明")
					// 	done(false)
					// }
				} else {
					done()
				}
			},
			// 显示异常详情
			showError: function(row) {
				let that = this
				let condition = {
					bq400guid: row.guid,
					currentPage: 1,
					pageSize: 9999,
					recordCount: 0,
				}

				that.$utils.HttpPost(that.$utils.Url.s400 + '/api/S400Bq400record/List', condition, function(d) {
					d.data.forEach((item) => {
						that.$utils.CopyKeyInfo(item, item)
					})
					that.errorList = d.data
					if(that.errorList.length>6){
						that.errorList = that.errorList.slice(-5)
					}
					//整理数据颜色图标
					that.errorList.forEach(item => {
						item.size = 'large'
						item.type = 'primary'
						if (item.bq400996 == "0") { //未提交
							item.color = '#409EFF'
							item.icon = 'el-icon-loading'
						}
						if (item.bq400996 == "1") { //转换中
							item.color = '#909399'
							item.icon = 'el-icon-edit'
						}
						if (item.bq400996 == "2") { //数据异常
							item.color = '#f56c6c'
							item.icon = 'el-icon-warning-outline'
						}
						if (item.bq400996 == "3") { //随访完成
							item.color = '#67c23a'
							item.icon = 'el-icon-check'
						}

					})
					that.showErrorDialog = true
				}, null, null, null)

			}
			// that.$utils.Url.s400 + '/S400/bq400record/list'
		},
		mounted() {
			// 设置默认MenuId
			// this.$http.defaults.headers.common["MenuId"] = "F8BE3B15-563E-A006-03F1-16E46D3C1A09";
		}
	}
</script>
<style scoped>
	.filter-box {
		font-size: 14px;
		color: #409EFF;
		letter-spacing: 0;
		text-align: left;
		line-height: 14px;
	}

	.patient-title {
		padding-right: 10px;
	}

	.patient-detail {
		padding-top: 3px;
	}

	.patient-detail .patient-detail-item {
		display: inline-block;
		font-size: 14px;
		color: #999999;
		line-height: 14px;
		font-weight: 400;
		padding-right: 10px;
	}

	.patient-detail .patient-status {
		display: inline-block;
		height: 20px;
		width: 60px;
		line-height: 20px;
		text-align: center;
		font-size: 10px !important;
		color: #FF7B61;
		background: rgba(255, 123, 97, 0.06);
		border: 1px solid #FF7B61;
		border-radius: 4px;
		box-sizing: border-box;
	}

	.patient-detail .patient-status.active {
		background: rgba(64, 158, 255, 0.06);
		border: 1px solid #409EFF;
		color: #409EFF;
	}

	.message {
		font-size: 13px;
	}
</style>
